// ==================== External Imports ==================== //
import React from "react"
import { Divider, Tab, Tabs, makeStyles, Theme } from "@material-ui/core"

// ==================== Local Imports ==================== //
import { a11yProps } from "util/helper"
import TabPanel from "components/TabPanel"
import EditProjectDialogUsers from "./EditProjectDialogUsers"
import EditProjectDialogProjectInformation from "./EditProjectDialogProjectInformation"

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    width: "100%",
    padding: theme.spacing(0, 0, 2.5, 2.5),
  },
}))

const EditProjectDialogBody: React.FC = () => {
  // ==================== Hooks ==================== //
  const classes = useStyles()

  // ==================== Use Hooks ==================== //
  const [value, setValue] = React.useState(0)

  // ==================== Functions ==================== //
  const handleChange = (
    event: React.ChangeEvent<Record<string, never>>,
    newValue: number
  ) => {
    setValue(newValue)
  }

  return (
    <div className={classes.container}>
      <Tabs
        indicatorColor="primary"
        value={value}
        onChange={handleChange}
        aria-label="edit user tab"
        style={{
          marginBottom: "0.25rem",
        }}
      >
        <Tab label="Project Information" {...a11yProps(0)} />
        <Tab label="Users" {...a11yProps(1)} />
      </Tabs>
      <Divider />
      <TabPanel value={value} index={0}>
        <EditProjectDialogProjectInformation />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <EditProjectDialogUsers />
      </TabPanel>
    </div>
  )
}

export default EditProjectDialogBody
